import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldX } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../Card';
interface HostBlockedProps {
  host: string;
}
export function HostBlocked({
  host
}: HostBlockedProps) {
  return <main className="flex min-h-[100dvh] w-full items-center justify-center bg-background px-5 py-12 sm:px-6" data-id="element-96" data-mp="m2pl6ubeixh1">
      <Card className="w-full max-w-sm" data-id="element-97" data-mp="h3usn0nmtujq">
        <CardHeader data-id="element-98" data-mp="h4wfs3hxa7ht">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-secondary text-secondary-foreground" data-id="element-99" data-mp="h18o79w1fv5q">
            <ShieldX className="h-4 w-4" aria-hidden="true" data-id="element-100" data-mp="82etjp29peut" />
          </span>
          <CardTitle className="mt-3" data-id="element-101" data-mp="84htb0t82mcq">Not available on this host</CardTitle>
          <CardDescription data-id="element-102" data-mp="354wbn8mzywf">
            The traffic dashboard is not served from production Turing domains. Open it from the
            internal Magic Patterns host instead.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4" data-id="element-103" data-mp="1xfs1do9l9l0o">
          <p className="font-mono text-xs text-muted-foreground" data-id="element-104" data-mp="3ud3vq3iopiug">Requested from: {host || '—'}</p>
          <Link to="/" className="inline-block text-sm text-foreground underline underline-offset-4" data-id="element-105" data-mp="29t8hwmp0iqg">
            Go to the maintenance page
          </Link>
        </CardContent>
      </Card>
    </main>;
}